import ComingSoonReleases from "../ComingSoon/ComingSoonReleases";

const Releases = () => {
    return(
        <div>
            <ComingSoonReleases/>
        </div>
    );
};

export default Releases;